import { render } from "./neworderSvg.vue?vue&type=template&id=92fe8488"
import script from "./neworderSvg.vue?vue&type=script&lang=js"
export * from "./neworderSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__